import { Controller } from "stimulus";
import { I18n } from "i18n-js";
import { TRANSLATIONS } from "../locales/translations.js";

let previousVariantId;
let selectedQuantity;
let causeIsSelected = false;
export default class extends Controller {
  static targets = [
    "modal",
    "button",
    "chosenCause",
    "causeList",
    "causeSelection",
    "confirmation",
    "changeCause",
    "main",
    "customerDonationsWidget",
    "donationOption",
    "customDisplay",
    "customInput",
    "collapsibleHeader",
    "bottomHalf",
    "caret"
  ];

  initialize() {
    this.saveCauseMetaData(this.chosenCauseTarget.dataset["metadata"]);
    if (this.causeSelectionTarget.dataset["chosenCause"] == "true") {
      causeIsSelected = true;
      if(this.element.dataset["chosenCauseVariantId"]) previousVariantId = this.element.dataset["chosenCauseVariantId"];
      selectedQuantity = this.causeSelectionTarget.dataset["quantity"];      
    }
    this.widgetSource = this.element.dataset["widgetSource"] || "cart";
    this.roundUp = this.element.dataset["roundUp"] == "1";
    this.fixedWholeAmt = this.element.dataset["fixedWholeAmt"] == "1";
    this.variantType = this.element.dataset["variantType"];
    this.customVariantType = this.element.dataset["customVariantType"];
    this.currencyRate = parseFloat(this.element.dataset["currencyRate"]);
    this.productValue = parseFloat(this.element.dataset["productValue"]);
    this.wholeProductValue = parseFloat(this.element.dataset["wholeProductValue"]);
    this.variantIds = [];
    this.centsVariantIds = [];
    if(this.causeListTargets.length > 0) {
      this.causeListTargets.forEach((cause) => {
        this.variantIds.push(cause.dataset["variantId"]);
        this.centsVariantIds.push(cause.dataset["centsVariantId"]);
      });
    } else {
      this.variantIds.push(this.chosenCauseTarget.dataset["variantId"]);
      this.centsVariantIds.push(this.chosenCauseTarget.dataset["centsVariantId"]);
    }
    this.defaultVariantId = this.element.dataset["defaultVariantId"];
    this.hasBundleFunction = this.element.dataset["bundleFunction"] == "1";
    console.log(`Has bundle func - ${this.hasBundleFunction}`);
    console.log(`Curr rate - ${this.currencyRate}`);
  }

  addCustomAmount(e) {
    if(this.customInputTarget.value && parseInt(this.customInputTarget.value) > 0) {
      selectedQuantity = parseInt(this.customInputTarget.value) / (this.customVariantType == "whole" ? this.wholeProductValue : this.productValue);
      this.selectCause(e);
    }
  }

  showCustom(e) {
    this.causeSelectionTargets.forEach(target => target.classList.add("d-none"));
    this.customDisplayTarget.classList.remove("d-none");
    this.customInputTarget?.focus();
  }

  connect() {
  parent.postMessage(JSON.stringify({checkChosenCauseOnLoad: true}), this.element.dataset.location );
    if(this.mainTarget?.dataset["donationOptions"]?.length)
      this.donationOptions = JSON.parse(this.mainTarget?.dataset["donationOptions"]);
    
    // Initialize collapsible functionality if enabled
    this.initCollapsible();
    
    // Send initial height to parent iframe
    this.sendCurrentHeight();
  }
  
  show() {
    this.modalTarget.classList.remove("d-none");
  }

  dismiss() {
    this.modalTarget.classList.add("d-none");
    if (causeIsSelected) {
      this.confirmationTarget.classList.remove("d-none");
      this.causeSelectionTargets.forEach(target => target.classList.add("d-none"));
    }
  }

  displayWidget(e) {
    console.log(this.element.dataset);
    let data = { shadowParent: this.element.dataset.shadowParent, widgetSource: this.widgetSource, showCustomerDonationsWidget: (this.element.dataset.result == 'true'), styles: JSON.parse(this.element.dataset.styles) };
    parent.postMessage(JSON.stringify(data), this.element.dataset.location );
    window.addEventListener("message", this.messageHandler.bind(this));
  }

  handleRequestHeight() {
    const loc = this.element.dataset.location;
    const shadowParent = this.element.dataset.shadowParent;
    for (let step = 0; step < 15; step++) {
      setTimeout(function() {
        let scrollH = document.querySelector("body").scrollHeight;
        let message = { shadowParent: shadowParent, customerDonationsHeight: scrollH };
        parent.postMessage(JSON.stringify(message), loc );
      }, step > 0 ? (step * 100) : 100);
    }
  }

  messageHandler(e) {
    try {
      let data = JSON.parse(e.data);
      if(data.requestHeight) this.handleRequestHeight();
      if(data.reloadChosenCause) this.showConfirmationMessage(null, data.quantity, previousVariantId);
      if(data.chosenCauseRemoved) this.resetWidget();
    } catch(e) { }
  }

  resetWidget() {
    this.causeSelectionTargets.forEach(target => {
      target.dataset["chosenCause"] = false;
      target.dataset["quantity"] = "";
      target.dataset["variantId"] = "";
      target.classList.remove("d-none");
    });
    causeIsSelected = false;
    previousVariantId = null;
    selectedQuantity = null;
    this.confirmationTarget.classList.add("d-none");
    this.changeCauseTarget.querySelector(".change-cause-text").classList.add("d-none");
    this.changeCauseTarget.querySelector(".learn-more-cta").classList.remove("d-none");
    this.handleRequestHeight();
  }

  selectCause(e) {
    let data;
    let variantId;
    const isCustom = e.currentTarget?.dataset["custom"];
    
    if(previousVariantId) {
      variantId = this.variantIds.includes(previousVariantId.toString()) ? this.chosenCauseTarget.dataset["variantId"] : this.chosenCauseTarget.dataset["centsVariantId"];
    } else {
      // For round-ups with custom amounts, use customVariantType instead of variantType
      // because custom amounts should always use the variant type appropriate for whole currency units
      if(this.roundUp && isCustom) {
        variantId = this.chosenCauseTarget.dataset[this.customVariantType == "whole" ? "variantId" : "centsVariantId"];
      } else if(this.variantType) {
        variantId = this.chosenCauseTarget.dataset[this.variantType == "whole" ? "variantId" : "centsVariantId"]
      } else {
        variantId = this.chosenCauseTarget.dataset[(this.roundUp && ((!isCustom) || this.currencyRate.toFixed() != 1)) || (this.currencyRate.toFixed() != 1 && isCustom) ? "centsVariantId" : "variantId"];
      }
    }
    if (causeIsSelected) {
      data = {
        changeCustomerCause: true,
        previousVariantId: previousVariantId,
        variantId: variantId,
        productId: this.mainTarget.dataset["productId"],
        quantity: selectedQuantity,
        amount: this.calculateAmount(variantId, selectedQuantity),
        widgetSource: this.widgetSource,
        defaultVariantId: this.defaultVariantId,
        hasBundleFunction: this.hasBundleFunction
      }
      this.showConfirmationMessage(null, selectedQuantity, variantId);
    } else {
      if(!selectedQuantity) {
        const quantity = e.currentTarget.dataset["quantity"];
        selectedQuantity = quantity;
      }
      data = {
        chooseCustomerCause: true,
        variantId: variantId,
        productId: this.mainTarget.dataset["productId"],
        quantity: selectedQuantity,
        amount: this.calculateAmount(variantId, selectedQuantity),
        widgetSource: this.widgetSource,
        defaultVariantId: this.defaultVariantId,
        hasBundleFunction: this.hasBundleFunction
      };
      this.mainTarget.classList.add("main-message-display");
      causeIsSelected = true;
      this.showConfirmationMessage(null, selectedQuantity, variantId);
      this.trackController.trackEvent(e.currentTarget, "added donation to cart", {...this.causeMetaData, ...{ amount: parseInt(e.currentTarget.dataset["quantity"]) }});
    }
    //Update the previous variant id
    previousVariantId = variantId;
    parent.postMessage(JSON.stringify(data), this.element.dataset.location);
  }

  reselectCause() {
    // show modal again
    this.mainTarget.classList.remove("main-message-display");
    this.show();
    this.confirmationTarget.classList.add("d-none");
    this.causeSelectionTargets.forEach(target => target.classList.remove("d-none"));
  }

  showConfirmationMessage(causeName = null, quantity, variantId = null) {
    this.customDisplayTarget.classList.add("d-none");
    // Check if only one cause
    if (this.changeCauseTarget.dataset["singleCause"] == "false") {
      this.changeCauseTarget.querySelector(".change-cause-text").classList.remove("d-none");
      this.changeCauseTarget.querySelector(".learn-more-cta").classList.add("d-none");
    }
    // Set styles in message div
    const donationAmountElement =
      this.confirmationTarget.querySelector(".donation-amount");
    const organizationNameElement =
      this.confirmationTarget.querySelector(".organization-name");

    let organizationName

    if (causeName) {
      organizationName = causeName;
    } else {
      organizationName = this.chosenCauseTarget.querySelector(
        ".cause-organization"
      ).innerHTML;
    }
    
    let currencySymbol = this.element.dataset.currency;

    const i18n = new I18n(TRANSLATIONS);
    i18n.locale = this.element.dataset.locale;
    let amount = this.calculateAmount(variantId, quantity);
    
    // Format currency according to locale
    const formattedAmount = new Intl.NumberFormat(this.element.dataset.locale || 'en', {
      style: 'currency',
      currency: this.element.dataset.currency || 'USD',
      currencyDisplay: 'narrowSymbol',
      // minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

    donationAmountElement.innerHTML = i18n.t("donation", { amount: formattedAmount });
    organizationNameElement.innerHTML = i18n.t("organization", { organizationName: organizationName });

    this.customerDonationsWidgetTarget.classList.add("vh-100");
    this.confirmationTarget.classList.remove("d-none");
    // Hide all causeSelection targets (there are multiple in cart drawer layout)
    this.causeSelectionTargets.forEach(target => target.classList.add("d-none"));
  }

  calculateUnitAmount(variantId, quantity) {
    let amount = 0;
    
    if(this.roundUp && this.centsVariantIds.includes(variantId) && this.productValue == quantity) {
      amount = this.productValue;
    } else {
      amount = this.centsVariantIds.includes(variantId) ? this.productValue : this.wholeProductValue;
    }
    return amount;
  }
  calculateAmount(variantId, quantity) {
    let amount = 0;
    
    if(this.roundUp && this.centsVariantIds.includes(variantId) && this.productValue == quantity) {
      amount = this.productValue;
    } else {
      const isCentsVariant = this.centsVariantIds.includes(variantId);
      amount = isCentsVariant ? this.productValue : this.wholeProductValue;
      console.log(`${(this.roundUp || this.fixedWholeAmt ? 1 : this.currencyRate)} - ${amount} - ${quantity}`);
      
      // For automatic round-ups with whole amount variants (quantity = 1), don't multiply by quantity
      // since the quantity is always 1 and the amount is already the full donation.
      // For custom amounts (quantity > 1), we DO multiply by quantity.
      if (!(this.roundUp && !isCentsVariant && quantity == 1)) {
        amount = ((this.roundUp || this.fixedWholeAmt ? 1 : this.currencyRate) * (amount * parseFloat(quantity)));
      }
    }
    console.log(`Calc amount = ${amount}`);
    return amount;
  }

  setSelectedCause(e) {    
    if(previousVariantId && e.currentTarget.dataset["variantId"].toString() == previousVariantId.toString()) {
      this.dismiss();
      return;
    }

    this.chosenCauseTarget.dataset["variantId"] =
      e.currentTarget.dataset["variantId"];
    
      this.chosenCauseTarget.dataset["centsVariantId"] =
      e.currentTarget.dataset["centsVariantId"];

    this.causeListTargets.forEach((cause) => cause.querySelector(".fa-check-circle").classList.add("d-none"));

    let checkBox = e.currentTarget.querySelector(".fa-check-circle")
    checkBox.classList.remove("d-none");
    this.chosenCauseTarget.querySelector(".cause-icon").innerHTML =
      e.currentTarget.querySelector(".cause-icon").innerHTML;
    this.chosenCauseTarget.querySelector(".cause-organization").innerHTML =
      e.currentTarget.querySelector(".cause-organization").innerHTML;
    
    this.saveCauseMetaData(e.currentTarget.dataset["metadata"]);


    if (causeIsSelected) {
      // Display impact options
      if(!this.roundUp && e.currentTarget.dataset["impactOptions"]?.length) {
        let impactOptions = JSON.parse(e.currentTarget.dataset["impactOptions"]);
        this.donationOptionTargets.forEach((optElm, idx) => {
          optElm.innerHTML = `<p class="my-2">${this.donationOptions[idx]}${impactOptions[idx] ? ` = <span class="accent">${impactOptions[idx]}</span></p>` : ''}`;
        });
      } else if(!this.roundUp) {
        // Display the normal options
        this.donationOptionTargets.forEach((optElm, idx) => {
          optElm.innerHTML = `<p class="my-2">${this.donationOptions[idx]}</p>`;
        });
      }
      this.selectCause(e);
    }

    !causeIsSelected && this.dismiss();
  }

  saveCauseMetaData(metadata) {
    if(metadata) this.causeMetaData = JSON.parse(metadata);
  }

  get trackController() {
    // const element = document.getElementById("customer_donations_widget") || 
    //               document.getElementById("customer_donations_cart_drawer_widget");
   
    return this.application.getControllerForElementAndIdentifier(this.element, "track")
  }

  initCollapsible() {
    // Only initialize if collapsible header exists (meaning collapsible is enabled)
    if (this.hasCollapsibleHeaderTarget) {
      // Set initial state based on the bottom-half class
      if (this.bottomHalfTarget.classList.contains('collapsed')) {
        this.bottomHalfTarget.style.height = '0px';
        this.bottomHalfTarget.style.overflow = 'hidden';
      }
    }
  }

  sendCurrentHeight() {
    // Send current widget height to parent iframe for proper sizing
    const currentHeight = document.querySelector("body").scrollHeight;
    parent.postMessage(JSON.stringify({
      shadowParent: this.element.dataset.shadowParent,
      customerDonationsHeight: currentHeight,

    }), this.element.dataset.location);
  }

  toggleCollapsible() {
    if (!this.hasBottomHalfTarget) return;

    const bottomHalf = this.bottomHalfTarget;
    const caret = this.hasCaretTarget ? this.caretTarget : null;
    const isCollapsing = !bottomHalf.classList.contains('collapsed');
    
    if (isCollapsing) {
      // Collapsing: animate to 0 height
      const currentHeight = bottomHalf.scrollHeight;
      bottomHalf.style.height = currentHeight + 'px';
      bottomHalf.style.overflow = 'hidden';
      bottomHalf.style.transition = 'height 0.3s ease, opacity 0.3s ease, transform 0.3s ease';
      
      // Force reflow
      bottomHalf.offsetHeight;
      
      // Animate to 0
      bottomHalf.style.height = '0px';
      bottomHalf.classList.remove('expanded');
      bottomHalf.classList.add('collapsed');
      if (caret) caret.classList.remove('expanded');
      
      // Calculate the collapsed height (header height + padding)
      const collapsibleHeader = this.hasCollapsibleHeaderTarget ? this.collapsibleHeaderTarget : null;
      const headerHeight = collapsibleHeader ? collapsibleHeader.offsetHeight : 0;
      const collapsedHeight = headerHeight + 40; // Add padding for safety
      
      // Send message to parent to adjust iframe height during collapse
      parent.postMessage(JSON.stringify({
        adjustIframeHeight: true, 
        isCollapsing: true,
        targetHeight: collapsedHeight
      }), this.element.dataset.location);
      
      // Clean up after animation
      setTimeout(() => {
        bottomHalf.style.transition = '';
        // Send final height after collapse animation completes
        this.sendCurrentHeight();
      }, 300);
      
    } else {
      // Expanding: measure content height and animate
      bottomHalf.style.height = '0px';
      bottomHalf.style.overflow = 'hidden';
      bottomHalf.classList.remove('collapsed');
      bottomHalf.classList.add('expanded');
      if (caret) caret.classList.add('expanded');
      
      // Get the natural height of the content
      const contentHeight = bottomHalf.scrollHeight;
      
      // Calculate total expanded height (header + content + padding)
      const collapsibleHeader = this.hasCollapsibleHeaderTarget ? this.collapsibleHeaderTarget : null;
      const headerHeight = collapsibleHeader ? collapsibleHeader.offsetHeight : 0;
      const totalExpandedHeight = headerHeight + contentHeight + 40; // Add padding for safety
      
      // Animate to the natural height
      bottomHalf.style.transition = 'height 0.3s ease, opacity 0.3s ease, transform 0.3s ease';
      bottomHalf.style.height = contentHeight + 'px';
      
      // Send message to parent to adjust iframe height during expansion
      parent.postMessage(JSON.stringify({
        adjustIframeHeight: true, 
        isCollapsing: false,
        targetHeight: totalExpandedHeight
      }), this.element.dataset.location);
      
      // After animation completes, remove height constraint
      setTimeout(() => {
        bottomHalf.style.height = 'auto';
        bottomHalf.style.overflow = 'visible';
        bottomHalf.style.transition = '';
        
        // Send final height after expansion animation completes
        this.sendCurrentHeight();
      }, 300);
    }
  }
}
